module.exports = __webpack_public_path__ + "img/4-1.7195ec52.svg";